/**
 * Derives the site identifier from the URL. Does NOT work on public sites like southcarolinablues.com.
 */
export function getSecureAemSiteIdentifier() {
    return window.location.pathname
        .replace('/content/commercial-web-my-health-toolkit', '')
        .split('/').slice(1, 3).join('_');
}

export function getSecureAemSiteLanguageCode() {
    return window.location.pathname
        .replace('/content/commercial-web-my-health-toolkit', '')
        .split('/')[3];
}